import Breadcrumb from 'components/breadcrumb/Breadcrumb';
import { BreadcrumbItem } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { BreadcrumbsWrapper } from './Breadcrumbs.styles';

const Breadcrumbs = ({ name, logo }: { name: string; logo: string }) => {
  const { t } = useTranslation();
  const location = useLocation();

  const previousPageHref = location.state?.from ?? '#/integrations';

  return (
    <BreadcrumbsWrapper className="breadcrumbs">
      <Breadcrumb>
        <BreadcrumbItem href={previousPageHref}>
          {t('pageIntegrations.integrationDetails.breadcrumb.integrations')}
        </BreadcrumbItem>

        <BreadcrumbItem active>
          <img src={logo} alt="logo" />

          {name}
        </BreadcrumbItem>
      </Breadcrumb>
    </BreadcrumbsWrapper>
  );
};

export default Breadcrumbs;
